function calculateTotalTaxPayable(totalQuantity, unitPrice, tax) {
  let totalWithoutTax = parseFloat(totalQuantity) * parseFloat(unitPrice);
  let totalTax = (totalWithoutTax / 100) * parseFloat(tax);
  totalTax = totalTax.toFixed(4);
  return totalTax;
}

function calculateTotalWithTax(totalQuantity, unitPrice, tax) {
  let totalWithoutTax = parseFloat(totalQuantity) * parseFloat(unitPrice);
  let totalTax = (totalWithoutTax / 100) * parseFloat(tax);
  totalTax = totalTax.toFixed(4);
  let totalIncludeTax = parseFloat(totalWithoutTax) + parseFloat(totalTax);
  return totalIncludeTax;
}

function getDateInDashFormat(date) {
  let formateDateinObj = new Date(date);
  let formatDate = formateDateinObj.toLocaleDateString("en-US");
  return formatDate;
}

export { calculateTotalTaxPayable, calculateTotalWithTax, getDateInDashFormat };
